import React, { useState, useEffect } from 'react';

export const CountdownTimer = ({ targetDate }) => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date().getTime();
      const distance = targetDate - now;

      if (distance > 0) {
        setTimeLeft({
          days: Math.floor(distance / (1000 * 60 * 60 * 24)),
          hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((distance % (1000 * 60)) / 1000)
        });
      } else {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [targetDate]);

  const TimeBlock = ({ value, label, size = 'normal' }) => (
    <div className={`countdown-block ${size === 'large' ? 'countdown-block-large' : ''} group`}>
      <div className={`countdown-number ${size === 'large' ? 'countdown-number-large' : ''}`}>{value}</div>
      <div className={`countdown-label ${size === 'large' ? 'countdown-label-large' : ''}`}>{label}</div>
    </div>
  );

  return (
    <div className="countdown-container">
      <div className="countdown-desktop">
        <TimeBlock value={timeLeft.days} label="Jours" />
        <TimeBlock value={timeLeft.hours} label="Heures" />
        <TimeBlock value={timeLeft.minutes} label="Minutes" />
        <TimeBlock value={timeLeft.seconds} label="Secondes" />
      </div>
      
      <div className="countdown-mobile">
        <div className="countdown-mobile-row-1">
          <TimeBlock value={timeLeft.days} label="Jours" size="large" />
        </div>
        <div className="countdown-mobile-row-2">
          <TimeBlock value={timeLeft.hours} label="Heures" size="small" />
          <TimeBlock value={timeLeft.minutes} label="Minutes" size="small" />
          <TimeBlock value={timeLeft.seconds} label="Secondes" size="small" />
        </div>
      </div>
    </div>
  );
};